import { getRequest } from '../services/requestHandler';
import { LieFraction } from '../models';

//4 for testing
export const getLieFractions = async (headTypeId = null) => {
  const url = headTypeId ? `loft/getLieFractions?headTypeId=${headTypeId}` : 'loft/getLieFractions';
  const response = await getRequest<LieFraction>('GetLieFractions', url);
  return response;
};
